var FilterEquipmentsModule = /** @class */ (function () {
    function FilterEquipmentsModule() {
    }
    return FilterEquipmentsModule;
}());
export { FilterEquipmentsModule };
